<div class="wrapp-pick">
    <h2 class="wrap-pick-configure__head" mat-dialog-draggable-title style="margin-bottom: 0px !important; cursor: text;">
        {{'header.display' | translate}}
        <mat-icon (click)="onCloseDialog()" class="close-popip-icon">close</mat-icon>
    </h2>

    <div class="wrap-popup">
        <div class="popup-head">
      <!-- <h4 class="popup-title">{{'header.display' | translate}}</h4> -->
            <span class="popup-tip">
                {{'header.tip_choose_display' | translate}}
            </span>
        </div>

        <div class="popup-main-content">
            <div class="wrap-checkbox">
                <div class="group-checkbox">
                    <label class="label-checkbox opacity-60" for="ekyc">
                        {{'search_form.service_type_allowOtp' | translate}}
                    </label>
                    <div class="wrap-button-checkbox">
                        <span class="descript-default">({{'header.default' | translate}})</span>
                    </div>
                </div>
                <div class="group-checkbox">
                    <label class="label-checkbox opacity-60" for="ekyc">
                        {{'search_form.service_type_allowImage' | translate}}
                    </label>
                    <div class="wrap-button-checkbox">
                        <span class="descript-default">({{'header.default' | translate}})</span>
                    </div>
                </div>
                <div class="group-checkbox" *ngIf="isShowEkyc">
                    <label class="label-checkbox" for="ekyc">
                        {{'search_form.service_type_supportEKYC' | translate}}
                    </label>
                    <div class="wrap-button-checkbox">
                        <button id="ekyc"
                        mat-icon-button
                        class="v2-color-deny"
                        (click)="onChangeStatus('supportEkyc')"
                        [disabled]="(count === 3) && (!showMethods.supportEkyc)"
                        >
                            <mat-icon *ngIf="showMethods.supportEkyc" class="mat-primary">check_box</mat-icon>
                            <mat-icon *ngIf="!showMethods.supportEkyc" class="mat-primary">check_box_outline_blank</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="group-checkbox">
                    <label class="label-checkbox" for="check-otp">
                        {{'search_form.service_type_checkOtp' | translate}}
                    </label>
                    <div class="wrap-button-checkbox">
                        <button
                        id="check-otp"
                        mat-icon-button class="v2-color-deny"
                        (click)="onChangeStatus('checkOtp')"
                        [disabled]="(count === 3) && (!showMethods.checkOtp)"
                        >
                            <mat-icon *ngIf="showMethods.checkOtp" class="mat-primary">check_box</mat-icon>
                            <mat-icon *ngIf="!showMethods.checkOtp" class="mat-primary">check_box_outline_blank</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="group-checkbox">
                    <label class="label-checkbox" for="check-name">
                        {{'search_form.service_type_checkName' | translate}}
                    </label>
                    <div class="wrap-button-checkbox">
                        <button
                        id="check-name"
                        mat-icon-button class="v2-color-deny"
                        (click)="onChangeStatus('checkName')"
                        [disabled]="(count === 3) && (!showMethods.checkName)"
                        >
                            <mat-icon *ngIf="showMethods.checkName" class="mat-primary">check_box</mat-icon>
                            <mat-icon *ngIf="!showMethods.checkName" class="mat-primary">check_box_outline_blank</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="group-checkbox">
                    <label class="label-checkbox" for="check-documents">
                        {{'search_form.service_type_checkCertNumber' | translate}}
                    </label>
                    <div class="wrap-button-checkbox">
                        <button
                        id="check-documents"
                        mat-icon-button class="v2-color-deny"
                        (click)="onChangeStatus('checkCertNumber')"
                        [disabled]="(count === 3) && (!showMethods.checkCertNumber)"
                        >
                            <mat-icon *ngIf="showMethods.checkCertNumber" class="mat-primary">check_box</mat-icon>
                            <mat-icon *ngIf="!showMethods.checkCertNumber" class="mat-primary">check_box_outline_blank</mat-icon>
                        </button>
                    </div>
                </div>

                <!-- EKYC -->
        <div class="group-checkbox" *ngIf="isReadySignEkyc">
                    <label class="label-checkbox" for="sign-ekyc">
            {{'search_form.service_type_allowEKYC' | translate}}
                    </label>
                    <div class="wrap-button-checkbox">
                        <button
                        id="sign-ekyc"
                        mat-icon-button class="v2-color-deny"
                        (click)="onChangeStatus('allowEKYC')"
                        [disabled]="(count === 3) && (!showMethods.allowEKYC)"
                        >
                            <mat-icon *ngIf="showMethods.allowEKYC" class="mat-primary">check_box</mat-icon>
                            <mat-icon *ngIf="!showMethods.allowEKYC" class="mat-primary">check_box_outline_blank</mat-icon>
                        </button>
                    </div>
                </div>

        <div class="group-checkbox" *ngIf="isReadySignEkycAdvanced">
                    <label class="label-checkbox" for="sign-advanced-ekyc">
            {{'search_form.service_type_allowEkycAdvanced' | translate}}
                    </label>
                    <div class="wrap-button-checkbox">
                        <button
                        id="sign-advanced-ekyc"
                        mat-icon-button class="v2-color-deny"
                        (click)="onChangeStatus('allowEkycAdvanced')"
                        [disabled]="(count === 3) && (!showMethods.allowEkycAdvanced)"
                        >
                            <mat-icon *ngIf="showMethods.allowEkycAdvanced" class="mat-primary">check_box</mat-icon>
                            <mat-icon *ngIf="!showMethods.allowEkycAdvanced" class="mat-primary">check_box_outline_blank</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
